import React from 'react';
import { useLocation } from 'react-router-dom';
import VehicleHistoryData from '../components/VehicleHistoryData';

function VehicleTrackHistory() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const device = params.get('device') || '';

  return (
    <div className='card card-custom'>
      <div className='card-header'>
        <div className='card-title'>
          <span className='fw-bolder'>TRACK HISTORY{device ? ` · ${device}` : ''}</span>
        </div>
      </div>
      <div className='card-body'>
        <VehicleHistoryData defaultDeviceName={device} />
      </div>
    </div>
  );
}

export default VehicleTrackHistory;
